import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import {
    buildSystemManifestQuery,
} from '../../utils/apiUtils';

export default function BagDetailLink(props) {
    
    const {
        isLoading,
        data: systemManifests,
    } = useQuery(buildSystemManifestQuery());

    if (isLoading)
    {
        return (<span>{props.bag.bagTag}</span>)
    }
    
    const systemOriginWhereBagDetailsLives = systemManifests.filter((x) => x.destinationSystemKey == "SmartSuite")[0].systemOrigin;
    const bagDetailUrl = `${systemOriginWhereBagDetailsLives}/Common.Airport/Query/BaggageDetails.aspx?baggage_id=${props.bag.id}`;

    return (
        <a href={bagDetailUrl} target="_blank">
            {props.bag.bagTag}
        </a>
    );
}

BagDetailLink.propTypes = {
    bag: PropTypes.instanceOf(Object).isRequired,
};
